import { useCopies } from "shared/hooks/useCopies";
import { PaymentService } from "../types";
import React from "react";
import { HtmlIdentifier } from "shared/utils/constants";
import classNames from "classnames";
import Button from "shared/components/button";
import Variant from "shared/enums/Variant";
import ButtonType from "shared/enums/ButtonTypes";
import Icon from "assets/icons";
import CancelPaymentButton from "./cancelButton";

export default function BraintreeComponent({
  showCardIcons,
  service,
  backToOfflineRequestedClickHandler
}: {
  showCardIcons: boolean;
  service: PaymentService;
  backToOfflineRequestedClickHandler?: () => void;
}) {
  const copies = useCopies();
  return (
    <React.Fragment>
      <div
        id={`${HtmlIdentifier.PAYMENT_CONTAINER}`}
        className={classNames("payment_container", {
          hideCardIcons: !showCardIcons
        })}></div>
      <div className="paymentWrapper_btnWrapper">
        <Button
          icon={<Icon.ShoppingBag />}
          label={copies.get("purchase")}
          variant={Variant.PRIMARY}
          type={ButtonType.BUTTON}
          onClick={service.getTokenForPayment}
          disabled={service.isPayButtonDisabled}
        />
        <CancelPaymentButton clickHandler={backToOfflineRequestedClickHandler} />
      </div>
    </React.Fragment>
  );
}
